import { render } from "./Monitoring.vue?vue&type=template&id=4b681f8e&scoped=true&ts=true"
import script from "./Monitoring.vue?vue&type=script&lang=ts"
export * from "./Monitoring.vue?vue&type=script&lang=ts"

import "./Monitoring.vue?vue&type=style&index=0&id=4b681f8e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b681f8e"]])

export default __exports__